import { bindActionCreators, Dispatch } from 'redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import { setSelectedTab } from '../../redux/modules/administration/administrationCreators';
import { connect } from 'react-redux';
import AdministrationPage from './AdministrationPage';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    selectedTab: state.administration.selectedTab,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setSelectedTab: bindActionCreators(setSelectedTab, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationPage);
